(function(root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.HanezzaCartController = api;
  if (root && root.document) api.autoInstall(root, root.document);
})(typeof globalThis !== 'undefined' ? globalThis : this, function() {
  'use strict';

  function normalizeRoot(value) {
    var root = String(value == null ? '/' : value).trim() || '/';
    if (root.charAt(0) !== '/') root = '/' + root;
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root;
  }

  async function parseJson(response) {
    try {
      return await response.json();
    } catch (_) {
      return {};
    }
  }

  function messageFrom(body, fallback) {
    if (body && typeof body.description === 'string' && body.description.trim()) return body.description.trim();
    if (body && typeof body.message === 'string' && body.message.trim()) return body.message.trim();
    return fallback;
  }

  function createCartClient(options) {
    options = options || {};
    var fetchImpl = options.fetchImpl;
    if (typeof fetchImpl !== 'function') throw new TypeError('fetchImpl is required');
    var onStatus = typeof options.onStatus === 'function' ? options.onStatus : function() {};
    var onCart = typeof options.onCart === 'function' ? options.onCart : function() {};
    var labels = options.labels || {};
    var routeRoot = normalizeRoot(options.routeRoot || '/');

    async function requestJson(url, requestOptions, fallback) {
      var response = await fetchImpl(url, requestOptions);
      var body = await parseJson(response);
      if (!response || response.ok !== true) {
        throw new Error(messageFrom(body, fallback));
      }
      return body;
    }

    async function refresh() {
      var cart = await requestJson(routeRoot + 'cart.js', {
        method: 'GET',
        headers: { Accept: 'application/json' }
      }, labels.genericError || 'Sepet okunamadı.');
      await onCart(cart);
      return cart;
    }

    async function add(formData) {
      onStatus('adding', labels.adding || 'Sepete ekleniyor…');
      try {
        await requestJson(routeRoot + 'cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' }
        }, labels.genericError || 'Ürün sepete eklenemedi.');
        var cart = await refresh();
        onStatus('success', labels.added || 'Sepete eklendi.');
        return cart;
      } catch (error) {
        var message = error && error.message ? error.message : (labels.genericError || 'Ürün sepete eklenemedi.');
        onStatus('error', message);
        throw error;
      }
    }

    return { add: add, refresh: refresh };
  }

  function formTargetsCartAdd(form) {
    if (!form) return false;
    var action = '';
    if (typeof form.getAttribute === 'function') action = form.getAttribute('action') || '';
    if (!action && form.action) action = form.action;
    return String(action).indexOf('/cart/add') !== -1;
  }

  function ensureFormStatus(form) {
    if (!form || typeof form.querySelector !== 'function') return null;
    var existing = form.querySelector('[data-hanezza-cart-form-status]');
    if (existing) return existing;
    if (!form.ownerDocument || typeof form.ownerDocument.createElement !== 'function') return null;
    var node = form.ownerDocument.createElement('div');
    node.setAttribute('data-hanezza-cart-form-status', '');
    node.setAttribute('role', 'status');
    node.setAttribute('aria-live', 'polite');
    node.setAttribute('aria-atomic', 'true');
    node.className = 'hanezza-cart-form-status';
    form.appendChild(node);
    return node;
  }

  function setCtaState(button, state, labels) {
    if (!button || !button.matches || !button.matches('[data-hanezza-cart-cta]')) return false;
    labels = labels || {};
    var label = button.querySelector && button.querySelector('[data-hanezza-cart-label]');
    var originalLabel = button.getAttribute('data-hanezza-cart-original-label');
    if (!originalLabel) {
      originalLabel = label ? String(label.textContent || '').trim() : '';
      if (originalLabel) button.setAttribute('data-hanezza-cart-original-label', originalLabel);
    }

    button.setAttribute('data-hanezza-cart-state', state || 'idle');
    if (label) {
      if (state === 'adding') label.textContent = 'Ekleniyor…';
      else if (state === 'success') label.textContent = 'Sepete Eklendi';
      else label.textContent = originalLabel || labels.add || 'Sepete Ekle';
    }
    return true;
  }

  function isMotionVisible(node) {
    if (!node || typeof node.getBoundingClientRect !== 'function') return false;
    var rect = node.getBoundingClientRect();
    if (!rect || rect.width <= 0 || rect.height <= 0) return false;
    var doc = node.ownerDocument;
    var win = doc && doc.defaultView;
    if (win && typeof win.getComputedStyle === 'function') {
      var style = win.getComputedStyle(node);
      if (!style || style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    }
    return true;
  }

  function motionReduced(doc) {
    var win = doc && doc.defaultView;
    return Boolean(win && typeof win.matchMedia === 'function' && win.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function findFlySource(doc) {
    if (!doc || typeof doc.querySelector !== 'function') return null;
    var candidates = [
      doc.getElementById && doc.getElementById('mobile-atc-img'),
      doc.querySelector('.hanezza-mobile-thumb.is-active img'),
      doc.querySelector('#mobile-image-slider img:not([hidden])'),
      doc.getElementById && doc.getElementById('sticky-img'),
      doc.querySelector('#desktop-gallery-scroll img')
    ];
    for (var i = 0; i < candidates.length; i += 1) {
      if (isMotionVisible(candidates[i])) return candidates[i];
    }
    return null;
  }

  function findCartTarget(doc) {
    if (!doc || typeof doc.querySelectorAll !== 'function') return null;
    var targets = Array.from(doc.querySelectorAll('[data-hanezza-cart-target], .mobile-header-fixed a[href="/cart"], .custom-icon-btn.cart-icon-wrapper, .mobile-bottom-nav-wrapper button[onclick*="StitchCartDrawer.open"], .tt-cart .tt-dropdown-toggle'));
    return targets.find(isMotionVisible) || null;
  }

  function animateFlyToCart(options) {
    options = options || {};
    var form = options.form || null;
    var root = options.root || null;
    var doc = form && form.ownerDocument
      ? form.ownerDocument
      : (root && root.nodeType === 9 ? root : root && root.ownerDocument);
    if (!doc || !doc.body || motionReduced(doc)) return Promise.resolve(false);

    var source = findFlySource(doc);
    var target = findCartTarget(doc);
    if (!source || !target) return Promise.resolve(false);

    var sourceRect = source.getBoundingClientRect();
    var targetRect = target.getBoundingClientRect();
    var src = source.currentSrc || source.src || '';
    if (!src || sourceRect.width <= 0 || sourceRect.height <= 0 || targetRect.width <= 0 || targetRect.height <= 0) {
      return Promise.resolve(false);
    }

    var fly = doc.createElement('img');
    fly.src = src;
    fly.alt = '';
    fly.setAttribute('aria-hidden', 'true');
    Object.assign(fly.style, {
      position: 'fixed',
      left: sourceRect.left + 'px',
      top: sourceRect.top + 'px',
      width: sourceRect.width + 'px',
      height: sourceRect.height + 'px',
      objectFit: 'cover',
      objectPosition: 'center top',
      borderRadius: '14px',
      boxShadow: '0 14px 34px rgba(38,20,42,.24)',
      border: '1px solid rgba(123,44,132,.24)',
      pointerEvents: 'none',
      zIndex: '10050',
      transformOrigin: '50% 50%',
      willChange: 'transform, opacity'
    });
    doc.body.appendChild(fly);

    var sourceCenterX = sourceRect.left + sourceRect.width / 2;
    var sourceCenterY = sourceRect.top + sourceRect.height / 2;
    var targetCenterX = targetRect.left + targetRect.width / 2;
    var targetCenterY = targetRect.top + targetRect.height / 2;
    var dx = targetCenterX - sourceCenterX;
    var dy = targetCenterY - sourceCenterY;
    var arc = Math.max(46, Math.min(110, Math.abs(dy) * .16 + 42));

    if (typeof fly.animate !== 'function') {
      if (fly.parentNode) fly.parentNode.removeChild(fly);
      return Promise.resolve(false);
    }

    var animation = fly.animate([
      { transform: 'translate3d(0,0,0) scale(1) rotate(0deg)', opacity: 1, offset: 0 },
      { transform: 'translate3d(' + (dx * .48) + 'px,' + ((dy * .42) - arc) + 'px,0) scale(.74) rotate(-4deg)', opacity: 1, offset: .52 },
      { transform: 'translate3d(' + (dx * .82) + 'px,' + ((dy * .76) - (arc * .34)) + 'px,0) scale(.42) rotate(5deg)', opacity: .92, offset: .82 },
      { transform: 'translate3d(' + dx + 'px,' + dy + 'px,0) scale(.14) rotate(8deg)', opacity: .08, offset: 1 }
    ], {
      duration: 620,
      easing: 'cubic-bezier(.16,1,.3,1)',
      fill: 'forwards'
    });

    return new Promise(function(resolve) {
      var finish = function() {
        if (fly.parentNode) fly.parentNode.removeChild(fly);
        if (typeof target.animate === 'function') {
          target.animate([
            { transform: 'scale(1)' },
            { transform: 'scale(1.13)' },
            { transform: 'scale(1)' }
          ], {
            duration: 240,
            easing: 'cubic-bezier(.16,1,.3,1)'
          });
        }
        resolve(true);
      };
      animation.onfinish = finish;
      animation.oncancel = finish;
    });
  }

  function bindCartForms(options) {
    options = options || {};
    var root = options.root;
    var client = options.client;
    var drawer = options.drawer || null;
    var labels = options.labels || {};
    if (!root || typeof root.addEventListener !== 'function') throw new TypeError('root is required');
    if (!client || typeof client.add !== 'function') throw new TypeError('client is required');

    async function onSubmit(event) {
      var form = event && event.target;
      if (!formTargetsCartAdd(form)) return;
      event.preventDefault();
      if (form.getAttribute && form.getAttribute('data-hanezza-cart-busy') === 'true') return;

      var button = event.submitter || (form.querySelector && form.querySelector('button[type="submit"], input[type="submit"]'));
      var originalHtml = button && 'innerHTML' in button ? button.innerHTML : null;
      var originalDisabled = button ? Boolean(button.disabled) : false;
      var originalAriaBusy = button && button.getAttribute ? button.getAttribute('aria-busy') : null;
      var statusNode = ensureFormStatus(form);

      if (form.setAttribute) form.setAttribute('data-hanezza-cart-busy', 'true');
      if (button) {
        button.disabled = true;
        if (button.setAttribute) button.setAttribute('aria-busy', 'true');
        setCtaState(button, 'adding', labels);
      }

      var succeeded = false;
      var failed = false;
      try {
        var cart = await client.add(new FormData(form));
        succeeded = true;
        setCtaState(button, 'success', labels);
        if (statusNode) statusNode.textContent = labels.added || 'Sepete eklendi.';
        await animateFlyToCart({ form: form, button: button, root: root });
        if (drawer && typeof drawer.open === 'function') drawer.open(button || form);
        return cart;
      } catch (error) {
        failed = true;
        setCtaState(button, 'error', labels);
        if (statusNode) statusNode.textContent = error && error.message ? error.message : (labels.genericError || 'Ürün sepete eklenemedi.');
        return null;
      } finally {
        var resetButton = function() {
          if (form.removeAttribute) form.removeAttribute('data-hanezza-cart-busy');
          if (statusNode && succeeded) statusNode.textContent = '';
          if (!button) return;
          button.disabled = originalDisabled;
          if (button.setAttribute && originalAriaBusy !== null) button.setAttribute('aria-busy', originalAriaBusy);
          else if (button.removeAttribute) button.removeAttribute('aria-busy');
          if (!setCtaState(button, 'idle', labels) && originalHtml !== null) button.innerHTML = originalHtml;
        };
        var resetDelay = succeeded ? 900 : (failed ? 450 : 0);
        if (resetDelay && typeof setTimeout === 'function') setTimeout(resetButton, resetDelay);
        else resetButton();
      }
    }

    root.addEventListener('submit', onSubmit);
    return function unbind() {
      if (typeof root.removeEventListener === 'function') root.removeEventListener('submit', onSubmit);
    };
  }

  function patchLegacyInterception(drawerApi, bind) {
    if (!drawerApi || typeof bind !== 'function') return false;
    drawerApi.interceptAddToCart = function() {
      if (this.__hanezzaCartControllerBound) return;
      this.__hanezzaCartControllerBound = true;
      bind(this);
    };
    return true;
  }

  function getFocusable(container) {
    if (!container || typeof container.querySelectorAll !== 'function') return [];
    return Array.prototype.filter.call(
      container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function(node) { return !node.hidden; }
    );
  }

  function installDialogBridge(drawerApi, doc) {
    if (!drawerApi || !doc) return false;
    var previousOpen = drawerApi.open;
    var previousClose = drawerApi.close;
    var returnFocus = null;
    var trapBound = false;

    function prepareDrawer() {
      var drawer = drawerApi.drawer || doc.getElementById('stitch-cart-drawer');
      if (!drawer) return null;
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      if (!drawerApi.isOpen) {
        drawer.setAttribute('aria-hidden', 'true');
        drawer.setAttribute('inert', '');
      }
      if (!trapBound && typeof drawer.addEventListener === 'function') {
        trapBound = true;
        drawer.addEventListener('keydown', function(event) {
          if (event.key !== 'Tab' || !drawerApi.isOpen) return;
          var focusable = getFocusable(drawer);
          if (!focusable.length) return;
          var first = focusable[0];
          var last = focusable[focusable.length - 1];
          if (event.shiftKey && doc.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && doc.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        });
      }
      return drawer;
    }

    drawerApi.open = function(trigger) {
      var drawer = prepareDrawer();
      returnFocus = trigger && typeof trigger.focus === 'function' ? trigger : doc.activeElement;
      if (typeof previousOpen === 'function') previousOpen.call(this);
      if (!drawer) return;
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      var close = doc.getElementById('stitch-drawer-close');
      if (close && typeof close.focus === 'function') close.focus();
    };

    drawerApi.close = function() {
      var drawer = prepareDrawer();
      if (typeof previousClose === 'function') previousClose.call(this);
      if (drawer) {
        drawer.setAttribute('aria-hidden', 'true');
        drawer.setAttribute('inert', '');
      }
      if (returnFocus && typeof returnFocus.focus === 'function' && returnFocus.isConnected !== false) returnFocus.focus();
      returnFocus = null;
    };

    prepareDrawer();
    return true;
  }

  function ensureDrawerStatus(doc) {
    var existing = doc.getElementById('HanezzaCartStatus');
    if (existing) return existing;
    var drawer = doc.getElementById('stitch-cart-drawer');
    if (!drawer || typeof doc.createElement !== 'function') return null;
    var node = doc.createElement('div');
    node.id = 'HanezzaCartStatus';
    node.className = 'stitch-cart-status';
    node.setAttribute('role', 'status');
    node.setAttribute('aria-live', 'polite');
    node.setAttribute('aria-atomic', 'true');
    var header = drawer.querySelector && drawer.querySelector('.stitch-drawer-header');
    if (header && header.parentNode) header.parentNode.insertBefore(node, header.nextSibling);
    else drawer.insertBefore(node, drawer.firstChild);
    return node;
  }

  function clearDrawerStatus(statusNode) {
    if (!statusNode) return;
    statusNode.textContent = '';
    if (statusNode.removeAttribute) statusNode.removeAttribute('data-status');
  }

  function textOnly(value, doc) {
    var raw = String(value == null ? '' : value);
    if (!doc || typeof doc.createElement !== 'function') return raw.replace(/<[^>]*>/g, '').trim();
    var node = doc.createElement('div');
    node.innerHTML = raw;
    return (node.textContent || '').trim();
  }

  function autoInstall(win, doc) {
    var drawerApi = win.StitchCartDrawer;
    if (!drawerApi) return false;

    var labels = {
      adding: textOnly(win.wait_text, doc) || 'Sepete ekleniyor…',
      added: textOnly(win.addedhtml_text, doc) || 'Sepete eklendi.',
      genericError: textOnly(win.errorhtml_text, doc) || 'Ürün sepete eklenemedi.',
      soldOut: textOnly(win.unavailable_text, doc) || 'Bu varyant tükendi.'
    };
    var statusNode = ensureDrawerStatus(doc);
    var statusClearTimer = null;
    installDialogBridge(drawerApi, doc);

    patchLegacyInterception(drawerApi, function(instance) {
      var client = createCartClient({
        fetchImpl: win.fetch.bind(win),
        routeRoot: win.Shopify && win.Shopify.routes ? win.Shopify.routes.root : '/',
        labels: labels,
        onStatus: function(status, message) {
          if (statusClearTimer) {
            clearTimeout(statusClearTimer);
            statusClearTimer = null;
          }
          if (statusNode) {
            statusNode.setAttribute('data-status', status);
            statusNode.textContent = message || '';
          }
          if (status === 'success' || status === 'error') {
            statusClearTimer = setTimeout(function() {
              clearDrawerStatus(statusNode);
              statusClearTimer = null;
            }, status === 'success' ? 1600 : 3600);
          }
          if (typeof instance.setLoading === 'function') instance.setLoading(status === 'adding');
        },
        onCart: function(cart) {
          var itemCount = cart.item_count || 0;
          if (itemCount === 0) {
            if (statusClearTimer) {
              clearTimeout(statusClearTimer);
              statusClearTimer = null;
            }
            clearDrawerStatus(statusNode);
          }
          if (typeof instance.updateBadges === 'function') instance.updateBadges(itemCount);
          if (typeof instance.updateTotals === 'function') instance.updateTotals(cart);
          if (typeof instance.toggleEmptyState === 'function') instance.toggleEmptyState(itemCount === 0);
          if (typeof instance.rebuildItems === 'function') instance.rebuildItems(cart);
        }
      });
      instance.hanezzaCartClient = client;
      bindCartForms({ root: doc, client: client, drawer: instance, labels: labels });
    });

    return true;
  }

  return {
    createCartClient: createCartClient,
    setCtaState: setCtaState,
    animateFlyToCart: animateFlyToCart,
    bindCartForms: bindCartForms,
    patchLegacyInterception: patchLegacyInterception,
    installDialogBridge: installDialogBridge,
    autoInstall: autoInstall
  };
});